import { FC } from 'react';
import { Center, Spinner, VStack, Text } from '@chakra-ui/react';

export const CenteredSpinner: FC = () => {
  return (
    <Center flex="1">
      <VStack>
        <Spinner size="xl" color="custom_orange.2" borderWidth="4px" />
        <Text color="custom_blue.1" fontSize="md" fontWeight="medium">
          Loading...
        </Text>
      </VStack>
    </Center>
  );
};
